<template>
  <section class="flex flex-col gap-4" data-test-id="setup-emails">
    <div class="flex items-start gap-4 rounded-lg border p-4">
      <span class="flex size-9 shrink-0 items-center justify-center rounded-md bg-accent text-accent-foreground">
        <MailIcon class="size-4.5" aria-hidden="true" />
      </span>
      <div class="flex flex-1 flex-col gap-0.5">
        <Label for="setup-transactional-emails" class="text-base font-semibold">
          {{ t('admin.platform.sections.emails.toggle.title') }}
        </Label>
        <p class="text-sm leading-normal text-muted-foreground">
          {{ t('admin.platform.sections.emails.toggle.description') }}
        </p>
      </div>
      <Checkbox
        id="setup-transactional-emails"
        :model-value="form.ENABLE_TRANSACTIONAL_EMAILS === 'true'"
        class="mt-1 size-5"
        data-test-id="setup-transactional-emails"
        @update:model-value="(value) => setEnabled(value === true)"
      />
    </div>

    <!-- Couper les e-mails bloque aussi « mot de passe oublié » : on le fait confirmer. -->
    <div
      v-if="isTurningOffRef"
      role="alert"
      class="flex flex-col gap-3 rounded-md bg-[#fff3dc] p-4 text-sm leading-relaxed"
      data-test-id="setup-emails-warning"
    >
      <p>{{ t('admin.platform.sections.emails.warning') }}</p>
      <label class="flex items-start gap-2.5 font-medium">
        <Checkbox v-model="confirmedRef" class="mt-0.5" data-test-id="setup-emails-confirm" />
        {{ t('admin.platform.sections.emails.confirm') }}
      </label>
    </div>

    <p class="text-xs text-muted-foreground">{{ t('admin.platform.sections.emails.soon') }}</p>
  </section>
</template>

<script setup lang="ts">
import { MailIcon } from 'lucide-vue-next'
import { computed } from 'vue'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { usePlatformSetup } from '@/features/admin/platform-setup/hooks/use-platform-setup.hook'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const { form, savedRef, emailsCutConfirmedRef: confirmedRef } = usePlatformSetup()

// On coupe des e-mails aujourd'hui actifs : il faut une confirmation explicite.
const isTurningOffRef = computed(
  () => form.ENABLE_TRANSACTIONAL_EMAILS !== 'true' && savedRef.value.ENABLE_TRANSACTIONAL_EMAILS === 'true',
)

function setEnabled(enabled: boolean) {
  form.ENABLE_TRANSACTIONAL_EMAILS = String(enabled)
  confirmedRef.value = false
}
</script>
